import {ButtonIcon as PeacockButtonIcon} from '@pepsico-ds/ui'

/**
 * @typedef {import('../BaseButton/BaseButton').BaseButtonProps & import('@pepsico-ds/ui').IButtonIconProps} ButtonIconProps
 * @property {boolean} [isMore] When true, renders a "more" icon style.
 * @property {string} [label] Tooltip label for icon button.
 * @property {'Interaction/Active' | 'Icon/Default' | 'Icon/High-Contrast-Inverse' | 'Feedback/Error'} [color] Optional text/icon color for naked variant.
 */

/**
 * Wrapper around Peacock DS ButtonIcon.
 * Supports base button props and button-icon-specific props.
 * @param {ButtonIconProps} props
 */

export const ButtonIcon = ({type = 'default', ...restProps}) => {
  return <PeacockButtonIcon type={type} {...restProps} />
}
